import { logger } from '@utils';
import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';
import * as RatingActions from './rating.actions';
import * as RatingWebsocket from './rating.websocket';
import { requestNativeStoreReview } from './nativeReview';
import { shouldDisplayRatingPrompt, shouldRequestNativeReview } from './rating.utils';

// Temporary release switch. Enabling this also enables backend requestTime tracking.
export const NATIVE_STORE_REVIEW_ENABLED = false;

export function* submitRating(action: any): SagaIterator {
  try {
    RatingWebsocket.submitRating(action.payload);
    yield put(RatingActions.dismissRatingPrompt());
  } catch (error) {
    logger.info(error);
  }
}

export function* requestRatingPrompt(): SagaIterator {
  try {
    const state:any = yield select();
    if (NATIVE_STORE_REVIEW_ENABLED && shouldRequestNativeReview(state)) {
      const requested: any = yield call(requestNativeStoreReview);
      if (requested) {
        RatingWebsocket.recordNativeReviewRequest({requestTime: Date.now()});
      }
    } else if (shouldDisplayRatingPrompt(state)) {
      yield put(RatingActions.displayRatingPrompt());
    }
  } catch (error) {
    logger.info(error);
  }
}



// WEBPACK FOOTER //
// ./src/services/rating/rating.saga.ts